import { AccountClient, GET_CLIENT_LIST_META_V2 } from '@nile/graphql';
import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedClientFilter';
import customViewConstraints from '@nile/components/src/Validators/customview/customView';

const CLIENT_VIEWS_META = {
  checkboxLabel: 'task.newView.checkbox.sharedView',
  roleToCheck: {
    add: 'clientViews.add',
    edit: 'clientViews.edit',
    delete: 'clientViews.delete',
    view: 'clientViews.view',
    sharedviewId: 'clientSharedViews.allow'
  },
  getModuleMeta: GET_CLIENT_LIST_META_V2,
  moduleMetaClient: AccountClient,
  moduleMetaInput: 'LIST_VIEW',
  moduleMetaResponseKey: 'getClientListViewMetaInfoV2',
  onValueSearch: onValueSearch,
  onAttributeSelect: onAttributeSelect,
  constraints: customViewConstraints,
  showColumns: true
};

export default CLIENT_VIEWS_META;
